export { default } from './PurchaseIncomes'
